function parseBundleIds(idBundle) {
  if (!idBundle) return [];
  if (typeof idBundle === 'string') {
    try {
      const parsed = JSON.parse(idBundle);
      if (Array.isArray(parsed)) {
        return parsed.map(item => item.id_bundle).filter(Boolean);
      }
    } catch (e) {
      if (idBundle.includes(',')) {
        return idBundle.split(',').map(s => s.trim().replace(/'/g, '')).filter(Boolean);
      }
      return idBundle.trim().replace(/'/g, '') ? [idBundle.trim().replace(/'/g, '')] : [];
    }
  }
  if (Array.isArray(idBundle)) {
    return idBundle.map(item => item.id_bundle).filter(Boolean);
  }
  return [];
}

function formatBundleIdsForDisplay(idBundle) {
  const bundles = parseBundleIds(idBundle);
  if (bundles.length === 0) return '-';
  return bundles.join(', ');
}

module.exports = { parseBundleIds, formatBundleIdsForDisplay };
